var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#640A55",
    fillRule: "evenodd",
    d: "M1.883 16.96 9.142 9.7c.37.331.786.607 1.238.818a5.08 5.08 0 0 0 3.925.143 5.1 5.1 0 0 0 1.58-.96l7.259 7.258zm6.058-8.447L.689 15.765V1.262zm16.397-7.226v14.478L17.102 8.53c2.443-2.383 4.837-4.815 7.236-7.242M23.143.067l-8.239 8.24c-.322.318-.699.573-1.119.744a3.4 3.4 0 0 1-2.657-.049 3.4 3.4 0 0 1-.94-.632l-.38-.365-.031-.04a.8.8 0 0 0-.156-.143C6.993 5.277 4.422 2.672 1.85.067z",
    clipRule: "evenodd"
  })));
};
export default SvgMail;